import React from "react"

export function Map({ children }: { children: any }) {
  return <div dangerouslySetInnerHTML={{ __html: children }}></div>
}
